export const CSSBlockPage = 'page-core';
